export const dataLocationList = [
  {
    longitude: 4.8357,
    latitude: 45.764,
    zoom: 6,
    region: 'FRANCE',
  },
  {
    longitude: 6.45,
    latitude: 45.48,
    longitudeLow: 6.25,
    longitudeHigh: 6.85,
    latitudeLow: 44.97,
    latitudeHigh: 46.15,
    zoom: 8.3,
    region: 'ALPES',
  },
  {
    longitude: 6.82,
    latitude: 45.58,
    longitudeLow: 6.42,
    longitudeHigh: 6.95,
    latitudeLow: 45.42,
    latitudeHigh: 45.63,
    zoom: 10,
    region: 'ALPES-NORD',
  },
  {
    longitude: 141.5,
    latitude: 43,
    longitudeLow: 138,
    longitudeHigh: 145,
    latitudeLow: 41,
    latitudeHigh: 45,
    zoom: 8,
    region: 'JAPON',
  },
  {
    longitude: 105.66,
    latitude: -0.1,
    longitudeLow: 90,
    longitudeHigh: 105,
    latitudeLow: 4,
    latitudeHigh: 7,
    zoom: 5,
    region: 'THAI-MAL-INDO',
  },
  {
    longitude: 73.6,
    latitude: 4.35,
    longitudeLow: 59,
    longitudeHigh: 75,
    latitudeLow: 2,
    latitudeHigh: 5,
    zoom: 12,
    region: 'MALDIVES',
  },
  {
    longitude: 57.4,
    latitude: -20.2,
    longitudeLow: 31,
    longitudeHigh: 57.5,
    latitudeLow: -20.3,
    latitudeHigh: -20.2,
    zoom: 13.1,
    region: 'MAURICE-ALBION',
  },
  {
    longitude: 57.4,
    latitude: -20.2,
    longitudeLow: 31,
    longitudeHigh: 57.5,
    latitudeLow: -21,
    latitudeHigh: -19,
    zoom: 8,
    region: 'MAURICE',
  },
  {
    longitude: 56,
    latitude: -12,
    longitudeLow: 31,
    longitudeHigh: 57.6,
    latitudeLow: -19,
    latitudeHigh: -5,
    zoom: 5,
    region: 'SEYCHELLES/MAURICE',
  },
  {
    longitude: 30.55,
    latitude: 36.63,
    longitudeLow: 28,
    longitudeHigh: 31,
    latitudeLow: 35,
    latitudeHigh: 38,
    zoom: 14.4,
    region: 'TURQUIE',
  },
  {
    longitudeLow: -92,
    longitudeHigh: -100,
    latitudeLow: 15,
    latitudeHigh: 19,
    zoom: 6,
    region: 'MEXIQUE',
  },
  {
    zoom: 14.3,
    region: 'OTHER',
  },
];
